import { IBudgetantrag } from "./IBudgetantrag";

export class Budgetantrag implements IBudgetantrag {
    
    static default = {
        budgetantragID: 0,
        wip: NaN,
        nr: NaN,
        antragsteller: "",
        antragsdatum: undefined,
        bezugsJahr: NaN,
        budgetplanReferenz: NaN,
        beschreibung: "",
        beschreibungValidated: false,
        beschreibungChanged: false,
        gesamtflaeche: NaN,
        gesamtflaecheValidated: false,    
        gesamtflaecheChanged: false,
        sonderflaeche: NaN,
        sonderflaecheValidated: false,    
        sonderflaecheChanged: false,
        laenge: NaN,
        breite:NaN,
        verwaltungsbereichID : NaN,
        controllingbereich: "",
        plangebiet: "",
		plangebietID: NaN,
        quartier: "",
        klassifizierung: "",
        filtergruppe: "",
        pm: "",
        pst: "",
        status: "",
        aktuelleBearbeitung: "",
        projektID: 0,
        projektName: "",
        lageplanDatum: undefined,
        lageplanDateiname: "",
        lageplanChanged: false,
        ursacheBudgetVeraenderung: "",
        freigabeFinal: false,
        bnkProzent: 20,
        bnk1bis4Prozent: 40,
        bnk5bis9Prozent: 60,
        bnkVeraenderung: "",
        ysnSeite1: false,
        ysnSeite2: false,
        ysnSeite3: false,
        ysnSeite4: false,
        endeChanged: false,
        antragstellerID: NaN, 
        pmID: NaN,
        pstID: NaN,
        kostengruppe: undefined,   
        kostenstelle: undefined,
        anfang: new Date(),
        ende: new Date(),
        endeBegruendung: undefined,
        wipName: "",
        wipBezeichnung: ""
    }

    constructor(
        public budgetantragID: number,
        public wip: number,
        public nr: number,
        public bezugsJahr: number,
        public budgetplanReferenz: number, 
        public antragsteller: string,
        public beschreibung: string,
        public beschreibungValidated: boolean,
        public beschreibungChanged: boolean,
        public gesamtflaeche: number,
        public gesamtflaecheValidated: boolean,    
        public gesamtflaecheChanged: boolean,
        public sonderflaecheValidated: boolean,    
        public sonderflaecheChanged: boolean,
        public laenge: number,
        public breite: number,
        public sonderflaeche: number,
        public lageplanDateiname: string,
        public lageplanChanged: boolean,
        public verwaltungsbereichID : number,
        public controllingbereich: string,
        public plangebiet: string,
		public plangebietID: number,
        public quartier: string,
        public klassifizierung: string,
        public filtergruppe: string,
        public pm: string,
        public pst: string,
        public status: string,
        public aktuelleBearbeitung: string,
        public projektID: number,
        public projektName: string,
        public freigabeFinal: boolean,
        public bnkProzent: number,
        public bnk1bis4Prozent: number,
        public bnk5bis9Prozent: number,
        public bnkVeraenderung: string,
        public ysnSeite1: boolean,
        public ysnSeite2: boolean,
        public ysnSeite3: boolean,
        public ysnSeite4: boolean,
        public anfang: Date,
        public ende: Date,
        public endeChanged: boolean,
        public antragstellerID: number,
        public pmID: number,
        public pstID: number,
        public wipName: string,
        public wipBezeichnung : string,
        public antragsdatum?: Date,
        public lageplanDatum?: Date,
        public ursacheBudgetVeraenderung?: string,
        public kostengruppe?: string,
        public kostenstelle?: string,
        public endeBegruendung?: string,
    ) {}
}

